const resource = {
    resource_identifier_in_use: 'API 标识符 {{indicator}} 已被使用',
    /** UNTRANSLATED */
    cannot_delete_management_api: 'Cannot delete Logto management API.',
};
export default Object.freeze(resource);
